<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 订单管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>开票申请</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.customerId" placeholder="请选择客户" filterable>
					<el-option key="" label="请选择客户" value=""></el-option>
					<el-option v-for="item in customersKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.status" placeholder="请选择状态">
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option v-for="item in statusKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="invoiceNo" label="单号" width="250"></el-table-column>
                <el-table-column prop="customerName" label="客户名称"></el-table-column>
				<el-table-column prop="amount" label="金额" width="150"></el-table-column>
				<el-table-column prop="status" label="状态" width="90" :formatter="statusFormat"></el-table-column>
				<el-table-column prop="createTime" label="申请时间" width="160"></el-table-column>
                <el-table-column label="操作" width="240" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show'] && scope.row.status > 0"
                        >详情</el-button>
						<el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleUpdate(scope.$index, scope.row)"
							v-if="controll['update'] && (scope.row.status == 2 || scope.row.status == 3) "
                        >更新</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete'] && scope.row.status == 0"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="70%">
            <el-form ref="form" :model="form">
				<el-form-item label="待开发票客户" prop="customerId">
					<el-select v-model="form.customerId" placeholder="请选择客户" filterable @change="onChangeCustomerId">
						<el-option key="" label="请选择客户" value=""></el-option>
						<el-option v-for="item in customersKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
                </el-form-item>
            </el-form>
			<el-table
				:data="orderList"
				border
				class="table"
				ref="multipleTable"
				header-cell-class-name="table-header"
				@selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
			>
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="orderNo" label="订单号"></el-table-column>
				<el-table-column prop="orderCompanyName" label="客户名称"></el-table-column>
				<el-table-column prop="total" label="数量" width="60"></el-table-column>
				<el-table-column prop="amount" label="金额" width="90"><template slot-scope="scope">￥{{scope.row.amount}}</template></el-table-column>
				<el-table-column prop="status" label="状态" :formatter="orderStatusFormat" width="80"></el-table-column>
				<el-table-column prop="createTime" label="下单时间" width="160"></el-table-column>
			</el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>申请</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="详情" :visible.sync="showVisible" width="70%">
            <el-form ref="show" :model="show" label-width="120px">
				<el-descriptions class="margin-top" title="" :column="3" size="medium" labelStyle="width:150px;" border>
					<el-descriptions-item>
						<template slot="label">
							客户名称
						</template>
						{{show.customerName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							发票代码
						</template>
						{{show.invoiceCode}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							发票编号
						</template>
						{{show.invoiceNo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							金额
						</template>
						{{show.amount}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							开票时间
						</template>
						{{show.billTime}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							开票人
						</template>
						{{show.drawer}}
					</el-descriptions-item><el-descriptions-item>
						<template slot="label">
							状态
						</template>
						{{statusFormat(null, null, show.status)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							备注
						</template>
						{{show.remark}}
					</el-descriptions-item>
				</el-descriptions>
				<el-row style="margin-top:20px">
					<el-table
						:data="salesDetailItems"
						border
						class="table"
						ref="multipleTable"
						header-cell-class-name="table-header"
						:cell-style="{padding:4+'px'}"
						stripe
					>
						<el-table-column prop="code" label="税收编码"></el-table-column>
						<el-table-column prop="name" label="开票名称" width="300"></el-table-column>
						<el-table-column prop="model" label="型号"></el-table-column>
						<el-table-column prop="num" label="数量"></el-table-column>
						<el-table-column prop="price" label="价格"></el-table-column>
						<el-table-column prop="amount" label="金额"></el-table-column>
						<el-table-column prop="channelName" label="渠道名称"></el-table-column>
					</el-table>
				</el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showVisible = false">取 消</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="状态更新" :visible.sync="updateVisible" width="70%">
            <el-form ref="update" :model="update" label-width="120px" :rules="updateRules">
				<el-form-item label="客户名称">
					{{update.customerName}}
				</el-form-item>
				<el-form-item label="当前状态">
					<el-select v-model="update.status" placeholder="请选择状态" prop="status">
						<el-option key="" label="请选择状态" value=""></el-option>
						<el-option v-for="item in statusKV2" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="备注">
					<el-input type=textarea :rows=5 v-model="update.remark" placeholder="发送方式，订单号，地址，联系人，电话等" ></el-input>
				</el-form-item>				
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateVisible = false">取 消</el-button>
				<el-button type="primary" @click="handleUpdateSave" v-prevent-re-click>更新</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchSalesData, saveSales, deleteSales, getSales, getCustomerKV, getNoInvoiceShipmentOrders, getSalesDetailBySalesId, updateSalesStatus } from '../../../api/index';
export default {
    name: 'sales',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
			orderList: [],
            multipleSelection: [],
            editVisible: false,
			showVisible: false,
			updateVisible : false,
            pageTotal: 0,
            form: {},
			show:{},
			update:{},
            idx: -1,
            id: -1,
			title:"",
			statusKV:[{"key":0,"value":"申请中"},{"key":1,"value":"开票中"},{"key":2,"value":"已开票"},{"key":3,"value":"已发出"},{"key":4,"value":"已签收"},{"key":5,"value":"已作废"}],
			statusKV2:[{"key":2,"value":"已开票"},{"key":3,"value":"已发出"},{"key":4,"value":"已签收"}],
			customersKV:[],
			salesDetailItems:[],
			updateRules: {
				status: [{ required: true, message: '请选择状态', trigger: 'blur' }]
			},
			controll:{}
        };
    },
    created() {
		this.controll = getControll("sales");
		this.getCustomers();
        this.getData();
    },
    methods: {
		statusFormat(row, column, cellValue) {
			for (var i = 0; i < this.statusKV.length; i++) {
				if (this.statusKV[i].key === cellValue){
					return this.statusKV[i].value;
				}
			}
			return cellValue;
		},
		//订单状态格式化
		orderStatusFormat(row, column, cellValue) {
			let statusConfig = {"0":"待审核","1":"待支付","2":"待发货","3":"发货中","4":"已发货","5":"已完结","6":"已撤销"};
			return statusConfig[cellValue];
		},
		//获取客户
		getCustomers() {
			getCustomerKV().then(res => {
				if (res.code == 0) {
					this.customersKV = res.data;
				} else {
					this.$message.error(`获取渠道信息失败！` + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchSalesData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
		onChangeCustomerId(value) {	
			this.orderList = [];
			if (this.form.customerId == undefined || this.form.customerId == "") {
				return;
			}
			getNoInvoiceShipmentOrders(value).then(res => {
				if (res.code == 0 ) {
					this.orderList = res.data;
				} else {
					this.$message.error("获取订单数据失败！" + res.message);
				}
			});
		},
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteSales([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.orderList = [];
			this.multipleSelection = [],
			this.title = "申请开票";
			this.editVisible = true;
		},
		//详情操作
		handleShow(index, row) {
			this.show = {};
			this.salesDetailItems = [];
			getSalesDetailBySalesId(row.id).then(res => {
				if (res.code == 0 ) {
					this.show = res.data[0];
					this.show['status'] = row['status'];
					this.show['remark'] = row['remark'];
					this.show['customerName'] = row['customerName'];
					this.salesDetailItems = JSON.parse(this.show.items);
					this.showVisible = true;
				} else {
					this.$message.error(res.message);
				}
			});
		},
		getAmount(id) {
			let index = this.orderList.findIndex(item => {
				if (item.id === id) {
					return true;
				}
			});
			return this.orderList[index].amount;
		},
		getCustomerName(key) {
			let index = this.customersKV.findIndex(item => {
				if (item.key === key) {
					return true;
				}
			});
			return this.customersKV[index].value;
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					const length = this.multipleSelection.length;
					if (length == 0) {
						this.$message.error(`请选择要申请开票的订单！`);
						return;
					}
					let ids = [];
					let total = 0;
					for (let i = 0; i < length; i++) {
						ids.push(this.multipleSelection[i].id);
						total = total + this.getAmount(this.multipleSelection[i].id);
					}
					this.form.orderIds = ids;
					this.form.customerName = this.getCustomerName(this.form.customerId); 
					this.form.amount = total;
					this.$confirm('开票订单' + length + '个, 金额：' + total + ',  确认无误？', '提示', {
						type: 'warning'
					})
						.then(() => {
							saveSales(this.form).then(res => {
								if (res.code == 0) {
									this.$message.success('申请提交成功！');
									this.editVisible = false;
									this.dealVisible = false;
									this.getData();
								} else {
									this.$message.error(`申请提交失败！` + res.message);
								}
							})
						})
						.catch(() => {});
					} else {
						this.$message.error('数据信息不完整！');
					}
			});
        },
		handleUpdate(index, row) {
			this.update = row;
			this.updateVisible = true;
		},
		handleUpdateSave(){
			this.$refs.update.validate(valid => {
				if (valid) {
					updateSalesStatus(this.update).then(res => {
						if (res.code == 0) {
							this.$message.success('更新成功！');
							this.updateVisible = false;
							this.getData();
						} else {
							this.$message.error(`更新失败！` + res.message);
						}
					});
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
		},
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
